import React, { useEffect, useState, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function NavContent() {
  return <div className="wrap py-4 flex items-center justify-between gap-4" data-id="element-227">
      <a href="#" className="inline-flex items-center gap-2" aria-label="Aisac — homepage" data-id="element-228">
        <img src="https://cdn.magicpatterns.com/uploads/shBw6JChJTUctMasMwCyEU/4_6021369468377112115.svg" alt="Aisac" className="h-7 md:h-8 w-auto" style={{
        filter: 'brightness(0) invert(1)'
      }} data-id="element-229" />
      </a>
      <a href="#cta" className="nav-cta-btn" data-id="element-230">
        Prova ora
        <ArrowRight className="w-4 h-4" data-id="element-231" />
      </a>
    </div>;
}
export function Nav() {
  const [showFixed, setShowFixed] = useState(false);
  const staticNavRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (staticNavRef.current) {
        const rect = staticNavRef.current.getBoundingClientRect();
        setShowFixed(rect.bottom < 0);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      {/* Static nav — overlays the Hero so the video shows through the glass */}
      <nav ref={staticNavRef} className="absolute top-0 left-0 right-0 z-50 backdrop-blur-2xl bg-[rgba(13,14,12,0.35)] border-b border-[rgba(255,255,255,0.06)]" data-id="element-232">
        <NavContent data-id="element-233" />
      </nav>

      {/* Fixed nav — slides in from top once the static nav scrolls out of view */}
      <AnimatePresence data-id="element-234">
        {showFixed && <motion.nav initial={{
        y: -80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -80,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 28
      }} className="fixed top-0 left-0 right-0 z-50 backdrop-blur-2xl bg-[rgba(13,14,12,0.45)] border-b border-[rgba(255,255,255,0.06)] shadow-[0_4px_30px_rgba(0,0,0,0.3)]" data-id="element-235">
            <NavContent data-id="element-236" />
          </motion.nav>}
      </AnimatePresence>
    </>;
}